/* @ngInject */
function timesheetTimeSpentFilter ($filter) {
  /**
   * @param {object} timeSpent
   * @param {object} timeSpent.minutes
   * @param {object} [timeSpent.hours]
   */
  return function (timeSpent) { // Example: 12:00:00+00
    if (!timeSpent) {
      return ''
    }

    const { hours, minutes } = timeSpent

    if (minutes && hours) {
      return `${hours}h ${minutes}m`
    }

    if (minutes) {
      return `${minutes}m`
    }

    return `${hours || 0}h`
  }
}

export { timesheetTimeSpentFilter }
